"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tokens = require("../../styles/tokens");
var styles = function styles(theme) {
  return {
    container: {
      display: 'inline-flex',
      // Match other input fields
      flexDirection: 'column' // Added to make the helpertext go underneath
    },
    // Hover Modifiers:
    // TODO: Fix in follow-up ticket
    // hover: {
    //     '& .hedtech-day': {
    //         backgroundColor: theme.palette.grey[250],
    //         width: '2.75rem !important',
    //         maxWidth: '2.75rem !important',
    //         borderRadius: '0 !important',
    //     },
    // },

    // Popper
    popper: {
      zIndex: theme.zIndex.drawer + 1
    },
    // IconContainer
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: "0 " + _tokens.spacing20,
      fill: theme.palette.grey[500]
    },
    iconContainerDisabled: {
      backgroundColor: theme.palette.grey[200]
    },
    // InputContainer
    inputContainer: {
      border: "solid " + _tokens.borderWidthThin + " " + theme.palette.grey[400] + " ",
      display: 'inline-flex',
      borderRadius: _tokens.borderRadiusMedium,
      height: 'auto',
      width: _tokens.widthInputFields,
      backgroundColor: theme.palette.grey[100]
    },
    inputContainerFullWidth: {
      width: '100%'
    },
    inputContainerDisabled: {
      backgroundColor: theme.palette.grey[200]
    },
    inputContainerError: {
      border: _tokens.borderWidthThick + " solid " + theme.palette.status.error.fill
    },
    inputContainerFocus: {
      boxShadow: _tokens.boxShadowFocus
    },
    // Small input
    smallDateRangePicker: {
      height: _tokens.heightInputFieldsSmall
    },
    smallDateRangePickerInput: {
      height: '2.25rem',
      padding: 0,
      '& input': {
        height: '1.25rem',
        padding: '0.4375rem',
        fontSize: _tokens.fontSizeDefault
      }
    },
    inputLabelSmall: {
      left: '0.625rem',
      fontSize: _tokens.fontSizeDefault,
      '&[data-shrink=true]': {
        display: 'none'
      },
      '&$inputLabelFormControl': {
        top: '-0.5625rem' // -9 px
      }
    },
    // Input
    inputRoot: {
      borderRadius: _tokens.borderRadiusMedium
    },
    input: {
      height: '1.25rem',
      padding: _tokens.paddingTextField,
      border: "solid " + _tokens.borderWidthThin + " transparent",
      '&::placeholder': {
        color: theme.palette.grey[500],
        opacity: 1
      },
      '&:focus': {
        border: "solid " + _tokens.borderWidthThin + " " + theme.palette.grey[400] + " ",
        boxShadow: _tokens.boxShadowFocus
      }
    },
    inputDisabled: {
      color: theme.palette.grey['500'],
      backgroundColor: theme.palette.grey[200],
      cursor: 'not-allowed',
      outline: 'none',
      '&:hover': {
        cursor: 'not-allowed',
        color: theme.palette.grey['500']
      },
      '&:active': {
        color: theme.palette.grey['500']
      }
    },
    startInput: {
      borderStartStartRadius: _tokens.borderRadiusMedium,
      borderEndStartRadius: _tokens.borderRadiusMedium
    },
    endInput: {
      borderStartEndRadius: _tokens.borderRadiusMedium,
      borderEndEndRadius: _tokens.borderRadiusMedium
    },
    inputFocused: {
      boxShadow: _tokens.boxShadowFocus,
      border: "solid " + _tokens.borderWidthThin + " " + theme.palette.grey[400] + " ",
      '&$inputFocusedError': {
        boxShadow: "0 0 0 " + _tokens.borderWidthThick + " " + theme.palette.status.error.fill,
        borderColor: "" + theme.palette.status.error.fill
      }
    },
    inputFocusedError: {
      '&:focus': {
        boxShadow: "0 0 0 " + _tokens.borderWidthThick + " " + theme.palette.status.error.fill,
        border: "solid " + _tokens.borderWidthThin + " " + theme.palette.status.error.fill
      }
    },
    // InputLabel
    inputLabelFormControl: {
      zIndex: _tokens.zIndexTextFieldLabel,
      left: _tokens.spacing40,
      top: '-0.1875rem',
      // -3 px
      transform: 'translate(0, 1.125rem) scale(1)'
    },
    inputLabelShrink: {
      fontSize: _tokens.fontSizeDefault,
      transform: 'translate(0, .5rem) scale(0.75)'
    }
  };
};
var _default = exports.default = styles;